import { Component } from '@angular/core';
import { LEASE_COLUMNS_ACTIVOS, LEASE_COLUMNS_CERRADOS, LEASE_COLUMNS_POR_ORIGINAR } from "@modules/private/lease/data/contstants/lease.constants";
import { ApiLeaseService } from "@modules/private/lease/data/services/api/api-lease.service";
import { LeaseService } from "@modules/private/lease/data/services/view/lease.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { ACTIONS } from "../data/contstants/lease.constants";

@Component({
  selector: 'app-lease-list',
  templateUrl: './lease-list.component.html',
  styleUrls: ['./lease-list.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class LeaseListComponent {
  //* 3 pestañas por fase del lease (status). additionalFilters fuerza el status por tab.
  porOriginarColumns = LEASE_COLUMNS_POR_ORIGINAR
  activosColumns = LEASE_COLUMNS_ACTIVOS
  cerradosColumns = LEASE_COLUMNS_CERRADOS
  porOriginarFilters = { status: { value: ['Pendiente', 'Aprobado'], matchMode: 'in' } }
  activosFilters = { status: { value: 'Activo', matchMode: 'equals' } }
  cerradosFilters = { status: { value: ['Liquidado', 'Cancelado'], matchMode: 'in' } }
  createEntity = false
  isSaving = false
  action = 'CREATE'
  additionalMainActions = [
    { label: 'Nuevo arrendamiento', icon: 'fa-solid fa-square-plus', action: 'CREATE', permission: ['leases', 'create'] as [string, string] }
  ]
  actions = ACTIONS

  constructor(
    private confirmationService: ConfirmationService,
    public apiLeaseService: ApiLeaseService,
    private messageService: MessageService,
    public leaseService: LeaseService,
  ) {
  }

  hideDialog() {
    this.createEntity = false;
  }

  mainActions(flow: string) {
    switch (flow) {
      case 'CREATE':
        this.leaseService.newEntity()
        this.createEntity = true
        break;
      default:
        console.log(flow)
        break;
    }
  }

  actionMethods(data: { event: any, action: string, data: any }) {
    switch (data.action) {
      case 'DELETE':
        this.deleteLease(data.event, data.data)
        break;
    }
  }

  deleteLease(event: Event, data: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `¿Estás seguro de que deseas eliminar el arrendamiento ${data.folio}?`,
      header: 'Confirmar eliminación',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",
      acceptLabel: 'Eliminar',
      rejectLabel: 'Cancelar',

      accept: () => {
        this.apiLeaseService.delete(data._id).subscribe(
          (response) => {
            this.apiLeaseService.getAll();
            this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Arrendamiento eliminado correctamente' });
            window.location.reload();
          },
          (error) => {
            console.error(error);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al eliminar el arrendamiento' });
          }
        );
      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: 'Cancelado', detail: 'Se cancelo la eliminación del arrendamiento' });
      }
    });
  }

  saveForm() {
    if (this.isSaving) return;
    this.isSaving = true;

    const formValue = this.leaseService.entity.value;
    
    // Solo enviar quotationParametersId al backend
    const entityToSend = {
      quotationParametersId: formValue.quotationParametersId
    };

    this.apiLeaseService.create(entityToSend).subscribe(
      (response) => {
        this.isSaving = false;
        this.hideDialog();
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Arrendamiento creado correctamente' });
        this.apiLeaseService.getAll(); // Recargar la lista después de crear
      },
      (error) => {
        this.isSaving = false;
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al crear el arrendamiento' });
      }
    );
  }
}
